import { FC } from "react";

import CheckIcon from "@material-ui/icons/Check";
import { Typography } from "@portex-pro/ui-components";
import partnerConnectSVG from "assets/partner-connect.svg";
import { useTranslation } from "react-i18next";

import PortexDialog from "../../../components/PortexDialog";

import "../css/PartnerConnectDialog.css";

type ComingSoonDialogProps = {
  open: boolean;
  onClose: () => void;
  partnerName: string;
  partnerLogo: string;
  portexLogo?: string;
  permissions?: string[];
  description?: string;
};

const PartnerComingSoonDialog: FC<ComingSoonDialogProps> = ({
  open,
  onClose,
  partnerName,
  partnerLogo,
  portexLogo,
  permissions = [],
  description,
}) => {
  const { t } = useTranslation(["benchmarkRateEstimates"]);

  return (
    <PortexDialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      title={t("benchmarkRateEstimates:comingSoonTitle", { partner: partnerName })}
      hideCancelButton
      hideDialogActions={false}
      cancelButtonCopy={t("benchmarkRateEstimates:closeButton", "Close")}
      onClickConfirm={onClose}
      confirmButtonCopy={t("benchmarkRateEstimates:closeButton", "Close")}
    >
      <div style={{ padding: 24 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
          <img src={partnerLogo} alt={partnerName} style={{ height: 88 }} />
          <img src={partnerConnectSVG} alt="Connect icon" style={{ marginLeft: 20, marginRight: 20 }} />
          {portexLogo ? (
            <img src={portexLogo} alt="Portex" style={{ height: 88 }} />
          ) : (
            <Typography variant="body1" style={{ fontWeight: "bold" }}>
              Portex
            </Typography>
          )}
        </div>

        <Typography variant="body1" paragraph>
          {description || t("benchmarkRateEstimates:comingSoonDescription", { partner: partnerName })}
        </Typography>

        {permissions.length > 0 && (
          <ul style={{ listStyle: "none", paddingLeft: 0, marginBottom: 0 }}>
            {permissions.map((perm, idx) => (
              <li key={idx} style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
                <CheckIcon style={{ color: "#0045FF", marginRight: 8 }} />
                <Typography variant="body1">{perm}</Typography>
              </li>
            ))}
          </ul>
        )}
      </div>
    </PortexDialog>
  );
};

export default PartnerComingSoonDialog;
